import { colors } from 'client/styles'

export const JET_IFRAME_PROVIDER_ID_TEST = 'wX63puMyforRm2Ps7Y5VETci8SdZKBeg'

export const JET_IFRAME_GLOBAL_CALLBACK_FUNCTION = 'jetIframeCallback'
export const JET_IFRAME_YEARS_COUNT_SELECTOR = 11
export const JET_IFRAME_INPUT_STYLES = `
    width: 100%;
    padding-block: 12px;
    padding-inline: 12px;
    font-size: 16px;
    color: ${colors.grey1};
    border: 2px solid ${colors.grey4};
    border-radius: 8px;
    box-sizing: border-box;
`

export const JET_IFRAME_RENDER_CHECK_INTERVAL = 1000
export const JET_IFRAME_RENDER_CHECK_TRIES = 10

export const CONFIRM_BUTTON_SUBMIT_VARIANT = 'confirmBooking'
export const CHANGE_CREDIT_CARD_BUTTON_SUBMIT_VARIANT = 'changeCreditCard'
